import { render, staticRenderFns } from "./DataTableCallsComponent.vue?vue&type=template&id=274cc88b&"
import script from "./DataTableCallsComponent.vue?vue&type=script&lang=js&"
export * from "./DataTableCallsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports